import { render, staticRenderFns } from "./turbo_sms.vue?vue&type=template&id=9d4400be&scoped=true&"
import script from "./turbo_sms.vue?vue&type=script&lang=js&"
export * from "./turbo_sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4400be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d4400be')) {
      api.createRecord('9d4400be', component.options)
    } else {
      api.reload('9d4400be', component.options)
    }
    module.hot.accept("./turbo_sms.vue?vue&type=template&id=9d4400be&scoped=true&", function () {
      api.rerender('9d4400be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/sms_provider/turbo_sms.vue"
export default component.exports